export const products = [
  // ELECTRONICS CATEGORY (15 products)
  {
    id: 1,
    name: "Wireless Bluetooth Headphones",
    price: 79.99,
    category: "Electronics",
    image: "https://images.unsplash.com/photo-1505740420928-5e560c06d30e?w=400&h=300&fit=crop",
    images: [
      "https://images.unsplash.com/photo-1505740420928-5e560c06d30e?w=400&h=300&fit=crop",
      "https://images.unsplash.com/photo-1572536147248-ac59a8abfa4b?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1yZWxhdGVkfDJ8fHxlbnwwfHx8fHw%3D",
      "https://images.unsplash.com/photo-1631586552668-b31039d4921d?q=80&w=1174&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
      "https://images.unsplash.com/photo-1583394838336-acd977736f90?w=400&h=300&fit=crop"
    ],
    description: "High-quality wireless headphones with noise cancellation and 20-hour battery life.",
    rating: 4.5,
    inStock: true,
    colors: ["Black", "White", "Silver"],
    sizes: ["One Size"]
  },
  {
    id: 2,
    name: "Smart Watch Series 5",
    price: 299.99,
    category: "Electronics",
    image: "https://images.unsplash.com/photo-1523275335684-37898b6baf30?w=400&h=300&fit=crop",
    images: [
      "https://images.unsplash.com/photo-1523275335684-37898b6baf30?w=400&h=300&fit=crop",
      "https://images.unsplash.com/photo-1508685096489-7aacd43bd3b1?w=400&h=300&fit=crop",
      "https://images.unsplash.com/photo-1579586337278-3f436f25d4d6?w=400&h=300&fit=crop",
      "https://images.unsplash.com/photo-1434493789847-2f02dc6ca35d?w=400&h=300&fit=crop"
    ],
    description: "Advanced smartwatch with health monitoring, GPS, and cellular connectivity.",
    rating: 4.8,
    inStock: true,
    colors: ["Space Gray", "Silver", "Gold", "Rose Gold"],
    sizes: ["38mm", "42mm", "44mm"]
  },
  {
    id: 3,
    name: "Wireless Phone Charger",
    price: 34.99,
    category: "Electronics",
    image: "https://images.unsplash.com/photo-1609091839311-d5365f9ff1c5?w=400&h=300&fit=crop",
    images: [
      "https://images.unsplash.com/photo-1609091839311-d5365f9ff1c5?w=400&h=300&fit=crop",
      "https://images.unsplash.com/photo-1586953208448-b95a79798f07?w=400&h=300&fit=crop",
      "https://images.unsplash.com/photo-1572569511254-d8f925fe2cbb?w=400&h=300&fit=crop",
      "https://images.unsplash.com/photo-1593642532973-d31b6557fa68?w=400&h=300&fit=crop"
    ],
    description: "Fast wireless charging pad compatible with all Qi-enabled devices.",
    rating: 4.3,
    inStock: false,
    colors: ["Black", "White"],
    sizes: ["One Size"]
  },
  {
    id: 4,
    name: "Laptop Stand",
    price: 49.99,
    category: "Electronics",
    image: "https://images.unsplash.com/photo-1527864550417-7fd91fc51a46?w=400&h=300&fit=crop",
    images: [
      "https://images.unsplash.com/photo-1527864550417-7fd91fc51a46?w=400&h=300&fit=crop",
      "https://images.unsplash.com/photo-1593642634524-b40b5baae6bb?w=400&h=300&fit=crop",
      "https://images.unsplash.com/photo-1581091226825-ca1d78e10c33?w=400&h=300&fit=crop",
      "https://images.unsplash.com/photo-1588776814341-2b1a43abf5d4?w=400&h=300&fit=crop"
    ],
    description: "Adjustable aluminum laptop stand for better ergonomics.",
    rating: 4.1,
    inStock: true,
    colors: ["Silver", "Space Gray"],
    sizes: ["One Size"]
  },
  {
    id: 5,
    name: "4K Webcam",
    price: 149.99,
    category: "Electronics",
    image: "https://images.unsplash.com/photo-1587825140708-dfaf72ae4b04?w=400&h=300&fit=crop",
    description: "Ultra HD 4K webcam with auto-focus and noise-canceling microphone.",
    rating: 4.6,
    inStock: true
  },
  {
    id: 6,
    name: "Gaming Mechanical Keyboard",
    price: 129.99,
    category: "Electronics",
    image: "https://images.unsplash.com/photo-1541140532154-b024d705b90a?w=400&h=300&fit=crop",
    images: [
      "https://images.unsplash.com/photo-1541140532154-b024d705b90a?w=400&h=300&fit=crop",
      "https://images.unsplash.com/photo-1587829741301-dc798b83cc31?w=400&h=300&fit=crop",
      "https://images.unsplash.com/photo-1618384887929-16ec33fab9ef?w=400&h=300&fit=crop",
      "https://images.unsplash.com/photo-1601445638532-3e6f8f8c9e9f?w=400&h=300&fit=crop"
    ],
    description: "RGB backlit mechanical keyboard with blue switches for gaming.",
    rating: 4.7,
    inStock: true,
    colors: ["Black", "White", "RGB"],
    sizes: ["Full Size", "Tenkeyless"]
  },
  {
    id: 7,
    name: "Wireless Gaming Mouse",
    price: 89.99,
    category: "Electronics",
    image: "https://images.unsplash.com/photo-1527814050087-3793815479db?w=400&h=300&fit=crop",
    images: [
      "https://images.unsplash.com/photo-1527814050087-3793815479db?w=400&h=300&fit=crop",
      "https://images.unsplash.com/photo-1591488320449-011701bb6701?w=400&h=300&fit=crop",
      "https://images.unsplash.com/photo-1527814050087-3793815479db?w=400&h=300&fit=crop",
      "https://images.unsplash.com/photo-1593085512500-5d55148d6f0d?w=400&h=300&fit=crop"
    ],
    description: "High-precision wireless gaming mouse with customizable RGB lighting.",
    rating: 4.4,
    inStock: true,
    colors: ["Black", "White"],
    sizes: ["One Size"]
  },
  {
    id: 8,
    name: "Portable Power Bank 20000mAh",
    price: 39.99,
    category: "Electronics",
    image: "https://images.unsplash.com/photo-1609081219090-a6d81d3085bf?w=400&h=300&fit=crop",
    images: [
      "https://images.unsplash.com/photo-1609592806787-3d8b9c3c4d6e?w=400&h=300&fit=crop",
      "https://images.unsplash.com/photo-1587731118093-5b3d5e9f1c7d?w=400&h=300&fit=crop",
      "https://images.unsplash.com/photo-1598936066287-5c8b8c9f8b8d?w=400&h=300&fit=crop",
      "https://images.unsplash.com/photo-1587731118093-5b3d5e9f1c7d?w=400&h=300&fit=crop"
    ],
    description: "High-capacity power bank with fast charging and multiple USB ports.",
    rating: 4.5,
    inStock: true,
    colors: ["Black", "White", "Blue"],
    sizes: ["20000mAh"]
  },
  {
    id: 9,
    name: "Bluetooth Speaker Waterproof",
    price: 59.99,
    category: "Electronics",
    image: "https://images.unsplash.com/photo-1608043152269-423dbba4e7e1?w=400&h=300&fit=crop",
    images: [
      "https://images.unsplash.com/photo-1608043152269-423dbba4e7e1?w=400&h=300&fit=crop",
      "https://images.unsplash.com/photo-1572569511254-d8f925fe2cbb?w=400&h=300&fit=crop",
      "https://images.unsplash.com/photo-1590658268037-6bf12165a8df?w=400&h=300&fit=crop",
      "https://images.unsplash.com/photo-1572569511254-d8f925fe2cbb?w=400&h=300&fit=crop"
    ],
    description: "Portable waterproof Bluetooth speaker with 360-degree sound.",
    rating: 4.3,
    inStock: true,
    colors: ["Black", "Blue", "Red"],
    sizes: ["Portable"]
  },
  {
    id: 10,
    name: "USB-C Hub 7-in-1",
    price: 69.99,
    category: "Electronics",
    image: "https://images.unsplash.com/photo-1625842268584-8f3296236761?w=400&h=300&fit=crop",
    images: [
      "https://images.unsplash.com/photo-1625842268584-8f3296236761?w=400&h=300&fit=crop",
      "https://images.unsplash.com/photo-1591488320449-011701bb6701?w=400&h=300&fit=crop",
      "https://images.unsplash.com/photo-1625842268584-8f3296236761?w=400&h=300&fit=crop",
      "https://images.unsplash.com/photo-1591488320449-011701bb6701?w=400&h=300&fit=crop"
    ],
    description: "Multi-port USB-C hub with HDMI, USB 3.0, and SD card reader.",
    rating: 4.2,
    inStock: true,
    colors: ["Space Gray", "Silver"],
    sizes: ["7-in-1"]
  },
  {
    id: 11,
    name: "Wireless Earbuds Pro",
    price: 199.99,
    category: "Electronics",
    image: "https://images.unsplash.com/photo-1590658268037-6bf12165a8df?w=400&h=300&fit=crop",
    images: [
      "https://images.unsplash.com/photo-1590658268037-6bf12165a8df?w=400&h=300&fit=crop",
      "https://images.unsplash.com/photo-1572569511254-d8f925fe2cbb?w=400&h=300&fit=crop",
      "https://images.unsplash.com/photo-1590658268037-6bf12165a8df?w=400&h=300&fit=crop",
      "https://images.unsplash.com/photo-1572569511254-d8f925fe2cbb?w=400&h=300&fit=crop"
    ],
    description: "Premium wireless earbuds with active noise cancellation.",
    rating: 4.8,
    inStock: true,
    colors: ["White", "Black", "Blue"],
    sizes: ["One Size"]
  },
  {
    id: 12,
    name: "Smart Home Security Camera",
    price: 119.99,
    category: "Electronics",
    image: "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=400&h=300&fit=crop",
    images: [
      "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=400&h=300&fit=crop",
      "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=400&h=300&fit=crop",
      "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=400&h=300&fit=crop",
      "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=400&h=300&fit=crop"
    ],
    description: "1080p HD security camera with night vision and motion detection.",
    rating: 4.4,
    inStock: true,
    colors: ["White", "Black"],
    sizes: ["Indoor", "Outdoor"]
  },
  {
    id: 13,
    name: "Tablet 10-inch Android",
    price: 249.99,
    category: "Electronics",
    image: "https://images.unsplash.com/photo-1544244015-0df4b3ffc6b0?w=400&h=300&fit=crop",
    images: [
      "https://images.unsplash.com/photo-1544244015-0df4b3ffc6b0?w=400&h=300&fit=crop",
      "https://images.unsplash.com/photo-1542751110-97427bbecf20?w=400&h=300&fit=crop",
      "https://images.unsplash.com/photo-1544244015-0df4b3ffc6b0?w=400&h=300&fit=crop",
      "https://images.unsplash.com/photo-1542751110-97427bbecf20?w=400&h=300&fit=crop"
    ],
    description: "10-inch Android tablet with 64GB storage and HD display.",
    rating: 4.1,
    inStock: true,
    colors: ["Black", "Silver"],
    sizes: ["64GB", "128GB"]
  },
  {
    id: 14,
    name: "LED Desk Lamp with USB Charging",
    price: 45.99,
    category: "Electronics",
    image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=300&fit=crop",
    images: [
      "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=300&fit=crop",
      "https://images.unsplash.com/photo-1581092162420-9a9c3f261c6f?w=400&h=300&fit=crop",
      "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=300&fit=crop",
      "https://images.unsplash.com/photo-1581092162420-9a9c3f261c6f?w=400&h=300&fit=crop"
    ],
    description: "Adjustable LED desk lamp with wireless charging pad and USB ports.",
    rating: 4.3,
    inStock: true,
    colors: ["White", "Black"],
    sizes: ["Adjustable"]
  },
  {
    id: 15,
    name: "Smart Fitness Tracker",
    price: 79.99,
    category: "Electronics",
    image: "https://images.unsplash.com/photo-1575311373937-040b8e1fd5b6?w=400&h=300&fit=crop",
    images: [
      "https://images.unsplash.com/photo-1575311373937-040b8e1fd5b6?w=400&h=300&fit=crop",
      "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=400&h=300&fit=crop",
      "https://images.unsplash.com/photo-1575311373937-040b8e1fd5b6?w=400&h=300&fit=crop",
      "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=400&h=300&fit=crop"
    ],
    description: "Fitness tracker with heart rate monitor and sleep tracking.",
    rating: 4.2,
    inStock: false,
    colors: ["Black", "Pink", "Blue"],
    sizes: ["Small", "Large"]
  },
  
  // CLOTHING CATEGORY (12 products)
  {
    id: 16,
    name: "Organic Cotton T-Shirt",
    price: 24.99,
    category: "Clothing",
    image: "https://images.unsplash.com/photo-1521572163474-6864f9cf17ab?w=400&h=300&fit=crop",
    images: [
      "https://images.unsplash.com/photo-1521572163474-6864f9cf17ab?w=400&h=300&fit=crop",
      "https://images.unsplash.com/photo-1581655353564-df123a1eb820?w=400&h=300&fit=crop",
      "https://images.unsplash.com/photo-1521572163474-6864f9cf17ab?w=400&h=300&fit=crop",
      "https://images.unsplash.com/photo-1581655353564-df123a1eb820?w=400&h=300&fit=crop"
    ],
    description: "Comfortable organic cotton t-shirt available in multiple colors.",
    rating: 4.2,
    inStock: true,
    colors: ["White", "Black", "Gray", "Navy"],
    sizes: ["S", "M", "L", "XL"]
  },
  {
    id: 22,
    name: "Denim Jacket",
    price: 89.99,
    category: "Clothing",
    image: "https://images.unsplash.com/photo-1551028719-00167b16eac5?w=400&h=300&fit=crop",
    images: [
      "https://images.unsplash.com/photo-1551028719-00167b16eac5?w=400&h=300&fit=crop",
      "https://images.unsplash.com/photo-1542272604-787383cf8ef8?w=400&h=300&fit=crop",
      "https://images.unsplash.com/photo-1551232864-3f0890e580d9?w=400&h=300&fit=crop",
      "https://images.unsplash.com/photo-1542272604-787383cf8ef8?w=400&h=300&fit=crop"
    ],
    description: "Classic denim jacket with a modern fit and comfortable wear.",
    rating: 4.5,
    inStock: true,
    colors: ["Light Blue", "Dark Blue", "Black"],
    sizes: ["S", "M", "L", "XL"]
  },
  {
    id: 23,
    name: "Casual Hoodie",
    price: 49.99,
    category: "Clothing",
    image: "https://images.unsplash.com/photo-1556821840-3a63f95609a7?w=400&h=300&fit=crop",
    images: [
      "https://images.unsplash.com/photo-1556821840-3a63f95609a7?w=400&h=300&fit=crop",
      "https://images.unsplash.com/photo-1556821840-3a63f95609a7?w=400&h=300&fit=crop",
      "https://images.unsplash.com/photo-1556821840-3a63f95609a7?w=400&h=300&fit=crop",
      "https://images.unsplash.com/photo-1556821840-3a63f95609a7?w=400&h=300&fit=crop"
    ],
    description: "Comfortable cotton blend hoodie perfect for casual wear.",
    rating: 4.4,
    inStock: true,
    colors: ["Gray", "Navy", "Black"],
    sizes: ["S", "M", "L", "XL"]
  },
  {
    id: 24,
    name: "Slim Fit Jeans",
    price: 79.99,
    category: "Clothing",
    image: "https://images.unsplash.com/photo-1542272604-787c3835535d?w=400&h=300&fit=crop",
    images: [
      "https://images.unsplash.com/photo-1542272604-787c3835535d?w=400&h=300&fit=crop",
      "https://images.unsplash.com/photo-1542272604-787c3835535d?w=400&h=300&fit=crop",
      "https://images.unsplash.com/photo-1542272604-787c3835535d?w=400&h=300&fit=crop",
      "https://images.unsplash.com/photo-1542272604-787c3835535d?w=400&h=300&fit=crop"
    ],
    description: "Premium slim fit jeans with stretch fabric for comfort.",
    rating: 4.3,
    inStock: true,
    colors: ["Blue", "Black"],
    sizes: ["28", "30", "32", "34"]
  },
  {
    id: 25,
    name: "Summer Dress",
    price: 69.99,
    category: "Clothing",
    image: "https://images.unsplash.com/photo-1595777457583-95e059d581b8?w=400&h=300&fit=crop",
    images: [
      "https://images.unsplash.com/photo-1595777457583-95e059d581b8?w=400&h=300&fit=crop",
      "https://images.unsplash.com/photo-1595777457583-95e059d581b8?w=400&h=300&fit=crop",
      "https://images.unsplash.com/photo-1595777457583-95e059d581b8?w=400&h=300&fit=crop",
      "https://images.unsplash.com/photo-1595777457583-95e059d581b8?w=400&h=300&fit=crop"
    ],
    description: "Elegant summer dress made from breathable fabric.",
    rating: 4.5,
    inStock: true,
    colors: ["Red", "Blue", "Yellow"],
    sizes: ["S", "M", "L", "XL"]
  },
  {
    id: 26,
    name: "Business Shirt",
    price: 59.99,
    category: "Clothing",
    image: "https://images.unsplash.com/photo-1602810318383-e386cc2a3ccf?w=400&h=300&fit=crop",
    images: [
      "https://images.unsplash.com/photo-1602810318383-e386cc2a3ccf?w=400&h=300&fit=crop",
      "https://images.unsplash.com/photo-1602810318383-e386cc2a3ccf?w=400&h=300&fit=crop",
      "https://images.unsplash.com/photo-1602810318383-e386cc2a3ccf?w=400&h=300&fit=crop",
      "https://images.unsplash.com/photo-1602810318383-e386cc2a3ccf?w=400&h=300&fit=crop"
    ],
    description: "Professional business shirt with wrinkle-resistant fabric.",
    rating: 4.2,
    inStock: true,
    colors: ["White", "Light Blue"],
    sizes: ["S", "M", "L", "XL"]
  },
  {
    id: 27,
    name: "Leather Jacket",
    price: 199.99,
    category: "Clothing",
    image: "https://images.unsplash.com/photo-1551028719-00167b16eac5?w=400&h=300&fit=crop",
    images: [
      "https://images.unsplash.com/photo-1551028719-00167b16eac5?w=400&h=300&fit=crop",
      "https://images.unsplash.com/photo-1551028719-00167b16eac5?w=400&h=300&fit=crop",
      "https://images.unsplash.com/photo-1551028719-00167b16eac5?w=400&h=300&fit=crop",
      "https://images.unsplash.com/photo-1551028719-00167b16eac5?w=400&h=300&fit=crop"
    ],
    description: "Genuine leather jacket with classic biker style.",
    rating: 4.8,
    inStock: false,
    colors: ["Black", "Brown"],
    sizes: ["S", "M", "L", "XL"]
  },
  {
    id: 28,
    name: "Yoga Pants",
    price: 39.99,
    category: "Clothing",
    image: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=400&h=300&fit=crop",
    images: [
      "https://images.unsplash.com/photo-1506629905607-d405d7d3b0d2?w=400&h=300&fit=crop",
      "https://images.unsplash.com/photo-1506629905607-d405d7d3b0d2?w=400&h=300&fit=crop",
      "https://images.unsplash.com/photo-1506629905607-d405d7d3b0d2?w=400&h=300&fit=crop",
      "https://images.unsplash.com/photo-1506629905607-d405d7d3b0d2?w=400&h=300&fit=crop"
    ],
    description: "High-waisted yoga pants with moisture-wicking fabric.",
    rating: 4.6,
    inStock: true,
    colors: ["Black", "Gray", "Navy"],
    sizes: ["S", "M", "L", "XL"]
  },
  {
    id: 29,
    name: "Winter Coat",
    price: 149.99,
    category: "Clothing",
    image: "https://images.unsplash.com/photo-1551028719-00167b16eac5?w=400&h=300&fit=crop",
    images: [
      "https://images.unsplash.com/photo-1539533018447-63fcce2678e6?w=400&h=300&fit=crop",
      "https://images.unsplash.com/photo-1539109136884-43be0c2dba59?w=400&h=300&fit=crop",
      "https://images.unsplash.com/photo-1539533018447-63fcce2678e6?w=400&h=300&fit=crop",
      "https://images.unsplash.com/photo-1539109136884-43be0c2dba59?w=400&h=300&fit=crop"
    ],
    description: "Warm winter coat with water-resistant outer shell and faux fur trim.",
    rating: 4.6,
    inStock: true,
    colors: ["Black", "Navy", "Red"],
    sizes: ["S", "M", "L", "XL"]
  },
  {
    id: 30,
    name: "Polo Shirt",
    price: 34.99,
    category: "Clothing",
    image: "https://images.unsplash.com/photo-1586790170083-2f9ceadc732d?w=400&h=300&fit=crop",
    images: [
      "https://images.unsplash.com/photo-1586790170083-2f9ceadc732d?w=400&h=300&fit=crop",
      "https://images.unsplash.com/photo-1586790170083-2f9ceadc732d?w=400&h=300&fit=crop",
      "https://images.unsplash.com/photo-1586790170083-2f9ceadc732d?w=400&h=300&fit=crop",
      "https://images.unsplash.com/photo-1586790170083-2f9ceadc732d?w=400&h=300&fit=crop"
    ],
    description: "Classic polo shirt made from premium cotton pique.",
    rating: 4.1,
    inStock: true,
    colors: ["White", "Light Blue"],
    sizes: ["S", "M", "L", "XL"]
  },
  {
    id: 31,
    name: "Sneakers White",
    price: 89.99,
    category: "Clothing",
    image: "https://images.unsplash.com/photo-1549298916-b41d501d3772?w=400&h=300&fit=crop",
    images: [
      "https://images.unsplash.com/photo-1549298916-b41d501d3772?w=400&h=300&fit=crop",
      "https://images.unsplash.com/photo-1549298916-b41d501d3772?w=400&h=300&fit=crop",
      "https://images.unsplash.com/photo-1549298916-b41d501d3772?w=400&h=300&fit=crop",
      "https://images.unsplash.com/photo-1549298916-b41d501d3772?w=400&h=300&fit=crop"
    ],
    description: "Classic white sneakers with comfortable cushioned sole.",
    rating: 4.4,
    inStock: true,
    colors: ["White", "Black"],
    sizes: ["6", "7", "8", "9", "10"]
  },
  {
    id: 32,
    name: "Formal Blazer",
    price: 129.99,
    category: "Clothing",
    image: "https://images.unsplash.com/photo-1594938298603-c8148c4dae35?w=400&h=300&fit=crop",
    images: [
      "https://images.unsplash.com/photo-1594938298603-c8148c4dae35?w=400&h=300&fit=crop",
      "https://images.unsplash.com/photo-1594938298603-c8148c4dae35?w=400&h=300&fit=crop",
      "https://images.unsplash.com/photo-1594938298603-c8148c4dae35?w=400&h=300&fit=crop",
      "https://images.unsplash.com/photo-1594938298603-c8148c4dae35?w=400&h=300&fit=crop"
    ],
    description: "Tailored formal blazer perfect for business occasions.",
    rating: 4.5,
    inStock: true,
    colors: ["Navy", "Black", "Gray"],
    sizes: ["S", "M", "L", "XL"]
  },
  // HOME & GARDEN CATEGORY (12 products)
  {
    id: 33,
    name: "Indoor Plant Monstera",
    price: 45.99,
    category: "Home & Garden",
    image: "https://images.unsplash.com/photo-1545241047-6083a3684587?w=400&h=300&fit=crop",
    description: "Beautiful monstera deliciosa plant perfect for indoor decoration.",
    rating: 4.6,
    inStock: true
  },
  {
    id: 34,
    name: "Ceramic Planter Set",
    price: 29.99,
    category: "Home & Garden",
    image: "https://images.unsplash.com/photo-1485955900006-10f4d324d411?w=400&h=300&fit=crop",
    description: "Set of 3 modern ceramic planters with drainage holes.",
    rating: 4.3,
    inStock: true
  },
  {
    id: 35,
    name: "Garden Tool Set",
    price: 79.99,
    category: "Home & Garden",
    image: "https://images.unsplash.com/photo-1416879595882-3373a0480b5b?w=400&h=300&fit=crop",
    description: "Complete 10-piece garden tool set with carrying case.",
    rating: 4.5,
    inStock: true
  },
  {
    id: 36,
    name: "Throw Pillow Set",
    price: 39.99,
    category: "Home & Garden",
    image: "https://images.unsplash.com/photo-1586023492125-27b2c045efd7?w=400&h=300&fit=crop",
    description: "Set of 4 decorative throw pillows in neutral colors.",
    rating: 4.2,
    inStock: true
  },
  {
    id: 37,
    name: "Wall Art Canvas Print",
    price: 59.99,
    category: "Home & Garden",
    image: "https://images.unsplash.com/photo-1513475382585-d06e58bcb0e0?w=400&h=300&fit=crop",
    description: "Modern abstract canvas print ready to hang.",
    rating: 4.4,
    inStock: true
  },
  {
    id: 38,
    name: "Bamboo Cutting Board",
    price: 24.99,
    category: "Home & Garden",
    image: "https://images.unsplash.com/photo-1544816155-12df9643f363?w=400&h=300&fit=crop",
    description: "Eco-friendly bamboo cutting board with juice groove.",
    rating: 4.7,
    inStock: true
  },
  {
    id: 39,
    name: "Essential Oil Diffuser",
    price: 49.99,
    category: "Home & Garden",
    image: "https://images.unsplash.com/photo-1544947950-fa07a98d237f?w=400&h=300&fit=crop",
    description: "Ultrasonic aromatherapy diffuser with LED lights.",
    rating: 4.5,
    inStock: true
  },
  {
    id: 40,
    name: "Outdoor String Lights",
    price: 34.99,
    category: "Home & Garden",
    image: "https://images.unsplash.com/photo-1578662996442-48f60103fc96?w=400&h=300&fit=crop",
    description: "25ft waterproof LED string lights for outdoor decoration.",
    rating: 4.6,
    inStock: true
  },
  {
    id: 41,
    name: "Memory Foam Bath Mat",
    price: 19.99,
    category: "Home & Garden",
    image: "https://images.unsplash.com/photo-1584622650111-993a426fbf0a?w=400&h=300&fit=crop",
    description: "Soft memory foam bath mat with non-slip backing.",
    rating: 4.3,
    inStock: true
  },
  {
    id: 42,
    name: "Wooden Spice Rack",
    price: 69.99,
    category: "Home & Garden",
    image: "https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=400&h=300&fit=crop",
    description: "Rotating wooden spice rack with 16 glass jars included.",
    rating: 4.4,
    inStock: false
  },
  {
    id: 43,
    name: "Decorative Mirror Round",
    price: 89.99,
    category: "Home & Garden",
    image: "https://images.unsplash.com/photo-1586023492125-27b2c045efd7?w=400&h=300&fit=crop",
    description: "Large round decorative mirror with gold frame.",
    rating: 4.5,
    inStock: true
  },
  {
    id: 44,
    name: "Herb Garden Kit",
    price: 32.99,
    category: "Home & Garden",
    image: "https://images.unsplash.com/photo-1416879595882-3373a0480b5b?w=400&h=300&fit=crop",
    description: "Indoor herb garden kit with seeds and growing supplies.",
    rating: 4.2,
    inStock: true
  },

  // FOOD & BEVERAGES CATEGORY (12 products)
  {
    id: 17,
    name: "Premium Coffee Beans",
    price: 18.99,
    category: "Food & Beverages",
    image: "https://images.unsplash.com/photo-1517701550927-30cf4ba1dba5?w=400&h=300&fit=crop",
    images: [
      "https://images.unsplash.com/photo-1517701550927-30cf4ba1dba5?w=400&h=300&fit=crop",
      "https://images.unsplash.com/photo-1514432324607-a09d9b4aefdd?w=400&h=300&fit=crop",
      "https://images.unsplash.com/photo-1511920170033-f8396924c348?w=400&h=300&fit=crop",
      "https://images.unsplash.com/photo-1514432324607-a09d9b4aefdd?w=400&h=300&fit=crop"
    ],
    description: "Freshly roasted premium Arabica coffee beans, 1kg pack.",
    rating: 4.7,
    inStock: true,
    variants: ["Light Roast", "Medium Roast", "Dark Roast"],
    weight: "1kg"
  },
  {
    id: 20,
    name: "Green Tea Collection",
    price: 22.99,
    category: "Food & Beverages",
    image: "https://images.unsplash.com/photo-1558642452-9d2a7deb7f62?w=400&h=300&fit=crop",
    description: "Assorted premium green tea collection with 6 different flavors.",
    rating: 4.5,
    inStock: true
  },
  {
    id: 45,
    name: "Organic Honey Raw",
    price: 16.99,
    category: "Food & Beverages",
    image: "https://images.unsplash.com/photo-1587049352846-4a222e784d38?w=400&h=300&fit=crop",
    description: "Pure raw organic honey from local beekeepers.",
    rating: 4.8,
    inStock: true
  },
  {
    id: 46,
    name: "Artisan Chocolate Box",
    price: 34.99,
    category: "Food & Beverages",
    image: "https://images.unsplash.com/photo-1549007994-cb92caebd54b?w=400&h=300&fit=crop",
    description: "Luxury chocolate collection with 12 unique flavors.",
    rating: 4.6,
    inStock: true
  },
  {
    id: 47,
    name: "Olive Oil Extra Virgin",
    price: 28.99,
    category: "Food & Beverages",
    image: "https://images.unsplash.com/photo-1474979266404-7eaacbcd87c5?w=400&h=300&fit=crop",
    description: "Cold-pressed extra virgin olive oil from Mediterranean olives.",
    rating: 4.4,
    inStock: true
  },
  {
    id: 48,
    name: "Protein Powder Vanilla",
    price: 49.99,
    category: "Food & Beverages",
    image: "https://images.unsplash.com/photo-1593095948071-474c5cc2989d?w=400&h=300&fit=crop",
    description: "Whey protein powder with natural vanilla flavor.",
    rating: 4.3,
    inStock: true
  },
  {
    id: 49,
    name: "Gourmet Pasta Set",
    price: 24.99,
    category: "Food & Beverages",
    image: "https://images.unsplash.com/photo-1551892374-ecf8754cf8b0?w=400&h=300&fit=crop",
    description: "Artisan pasta collection with 4 different shapes and sauces.",
    rating: 4.5,
    inStock: true
  },
  {
    id: 50,
    name: "Craft Beer Variety Pack",
    price: 39.99,
    category: "Food & Beverages",
    image: "https://images.unsplash.com/photo-1608270586620-248524c67de9?w=400&h=300&fit=crop",
    description: "12-pack variety of craft beers from local breweries.",
    rating: 4.2,
    inStock: false
  },
  {
    id: 51,
    name: "Spice Blend Collection",
    price: 29.99,
    category: "Food & Beverages",
    image: "https://images.unsplash.com/photo-1596040033229-a9821ebd058d?w=400&h=300&fit=crop",
    description: "Set of 8 premium spice blends from around the world.",
    rating: 4.6,
    inStock: true
  },
  {
    id: 52,
    name: "Matcha Powder Premium",
    price: 32.99,
    category: "Food & Beverages",
    image: "https://images.unsplash.com/photo-1515823064-d6e0c04616a7?w=400&h=300&fit=crop",
    description: "Ceremonial grade matcha powder from Japan.",
    rating: 4.7,
    inStock: true
  },
  {
    id: 53,
    name: "Nuts & Dried Fruits Mix",
    price: 19.99,
    category: "Food & Beverages",
    image: "https://images.unsplash.com/photo-1599599810769-bcde5a160d32?w=400&h=300&fit=crop",
    description: "Premium mix of nuts and dried fruits for healthy snacking.",
    rating: 4.4,
    inStock: true
  },
  {
    id: 54,
    name: "Kombucha Starter Kit",
    price: 27.99,
    category: "Food & Beverages",
    image: "https://images.unsplash.com/photo-1559181567-c3190ca9959b?w=400&h=300&fit=crop",
    description: "Complete kit to brew your own kombucha at home.",
    rating: 4.1,
    inStock: true
  },
  // SPORTS & FITNESS CATEGORY (12 products)
  {
    id: 18,
    name: "Yoga Mat Premium",
    price: 45.99,
    category: "Sports & Fitness",
    image: "https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?w=400&h=300&fit=crop",
    description: "Non-slip premium yoga mat with extra cushioning for comfort.",
    rating: 4.4,
    inStock: true
  },
  {
    id: 21,
    name: "Running Shoes",
    price: 129.99,
    category: "Sports & Fitness",
    image: "https://images.unsplash.com/photo-1542291026-7eec264c27ff?w=400&h=300&fit=crop",
    description: "Lightweight running shoes with advanced cushioning technology.",
    rating: 4.9,
    inStock: true
  },
  {
    id: 55,
    name: "Resistance Bands Set",
    price: 24.99,
    category: "Sports & Fitness",
    image: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=400&h=300&fit=crop",
    description: "Complete resistance bands set with door anchor and handles.",
    rating: 4.3,
    inStock: true
  },
  {
    id: 56,
    name: "Adjustable Dumbbells",
    price: 199.99,
    category: "Sports & Fitness",
    image: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=400&h=300&fit=crop",
    images: [
      "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=400&h=300&fit=crop",
      "https://images.unsplash.com/photo-1581009146145-b5ef050c2e1e?w=400&h=300&fit=crop",
      "https://images.unsplash.com/photo-1571019614242-c5c5dee9f725?w=400&h=300&fit=crop",
      "https://images.unsplash.com/photo-1581009146145-b5ef050c2e1e?w=400&h=300&fit=crop"
    ],
    description: "Space-saving adjustable dumbbell set with multiple weight options.",
    rating: 4.8,
    inStock: true,
    colors: ["Black", "Gray"],
    weightRange: "5-50 lbs"
  },
  {
    id: 57,
    name: "Foam Roller",
    price: 29.99,
    category: "Sports & Fitness",
    image: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=400&h=300&fit=crop",
    description: "High-density foam roller for muscle recovery and massage.",
    rating: 4.4,
    inStock: true
  },
  {
    id: 58,
    name: "Water Bottle Insulated",
    price: 19.99,
    category: "Sports & Fitness",
    image: "https://images.unsplash.com/photo-1523362628745-0c100150b504?w=400&h=300&fit=crop",
    description: "32oz stainless steel insulated water bottle keeps drinks cold 24hrs.",
    rating: 4.5,
    inStock: true
  },
  {
    id: 59,
    name: "Exercise Ball",
    price: 34.99,
    category: "Sports & Fitness",
    image: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=400&h=300&fit=crop",
    description: "Anti-burst exercise ball with pump for core strengthening.",
    rating: 4.2,
    inStock: true
  },
  {
    id: 60,
    name: "Jump Rope Speed",
    price: 15.99,
    category: "Sports & Fitness",
    image: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=400&h=300&fit=crop",
    description: "Adjustable speed jump rope with ball bearing system.",
    rating: 4.1,
    inStock: true
  },
  {
    id: 61,
    name: "Gym Gloves",
    price: 22.99,
    category: "Sports & Fitness",
    image: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=400&h=300&fit=crop",
    description: "Breathable workout gloves with wrist support and grip padding.",
    rating: 4.3,
    inStock: true
  },
  {
    id: 62,
    name: "Protein Shaker Bottle",
    price: 12.99,
    category: "Sports & Fitness",
    image: "https://images.unsplash.com/photo-1523362628745-0c100150b504?w=400&h=300&fit=crop",
    description: "BPA-free protein shaker with mixing ball and measurement marks.",
    rating: 4.0,
    inStock: true
  },
  {
    id: 63,
    name: "Yoga Blocks Set",
    price: 18.99,
    category: "Sports & Fitness",
    image: "https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?w=400&h=300&fit=crop",
    description: "Set of 2 high-density foam yoga blocks for support and alignment.",
    rating: 4.4,
    inStock: false
  },
  {
    id: 64,
    name: "Kettlebell 20lb",
    price: 49.99,
    category: "Sports & Fitness",
    image: "https://images.unsplash.com/photo-1517963879433-6ad2b056d712?w=400&h=300&fit=crop",
    description: "Cast iron kettlebell with wide handle for functional training.",
    rating: 4.5,
    inStock: true
  },

  // BEAUTY & PERSONAL CARE CATEGORY (12 products)
  {
    id: 65,
    name: "Skincare Set Anti-Aging",
    price: 89.99,
    category: "Beauty & Personal Care",
    image: "https://images.unsplash.com/photo-1556228720-195a672e8a03?w=400&h=300&fit=crop",
    description: "Complete anti-aging skincare set with cleanser, serum, and moisturizer.",
    rating: 4.6,
    inStock: true
  },
  {
    id: 66,
    name: "Electric Toothbrush",
    price: 79.99,
    category: "Beauty & Personal Care",
    image: "https://images.unsplash.com/photo-1607613009820-a29f7bb81c04?w=400&h=300&fit=crop",
    description: "Sonic electric toothbrush with 5 cleaning modes and timer.",
    rating: 4.5,
    inStock: true
  },
  {
    id: 67,
    name: "Hair Dryer Ionic",
    price: 59.99,
    category: "Beauty & Personal Care",
    image: "https://images.unsplash.com/photo-1522338242992-e1a54906a8da?w=400&h=300&fit=crop",
    description: "Professional ionic hair dryer with multiple heat settings.",
    rating: 4.3,
    inStock: true
  },
  {
    id: 68,
    name: "Face Mask Sheet Set",
    price: 24.99,
    category: "Beauty & Personal Care",
    image: "https://images.unsplash.com/photo-1556228720-195a672e8a03?w=400&h=300&fit=crop",
    description: "Set of 10 hydrating sheet masks with different ingredients.",
    rating: 4.2,
    inStock: true
  },
  {
    id: 69,
    name: "Makeup Brush Set",
    price: 39.99,
    category: "Beauty & Personal Care",
    image: "https://images.unsplash.com/photo-1596462502278-27bfdc403348?w=400&h=300&fit=crop",
    description: "Professional 12-piece makeup brush set with carrying case.",
    rating: 4.4,
    inStock: true
  },
  {
    id: 70,
    name: "Perfume Eau de Parfum",
    price: 69.99,
    category: "Beauty & Personal Care",
    image: "https://images.unsplash.com/photo-1541643600914-78b084683601?w=400&h=300&fit=crop",
    description: "Luxury eau de parfum with floral and citrus notes.",
    rating: 4.7,
    inStock: true
  },
  {
    id: 71,
    name: "Nail Polish Set",
    price: 29.99,
    category: "Beauty & Personal Care",
    image: "https://images.unsplash.com/photo-1522335789203-aabd1fc54bc9?w=400&h=300&fit=crop",
    images: [
      "https://images.unsplash.com/photo-1607602132700-068d08d383ec?w=400&h=300&fit=crop",
      "https://images.unsplash.com/photo-1607602132700-068d08d383ec?w=400&h=300&fit=crop",
      "https://images.unsplash.com/photo-1607602132700-068d08d383ec?w=400&h=300&fit=crop",
      "https://images.unsplash.com/photo-1607602132700-068d08d383ec?w=400&h=300&fit=crop"
    ],
    description: "Set of 6 long-lasting nail polish colors in trendy shades.",
    rating: 4.3,
    inStock: true,
    colors: ["Red", "Pink", "Nude", "Black", "Blue", "Purple"],
    setSize: 6
  },
  {
    id: 72,
    name: "Body Lotion Organic",
    price: 19.99,
    category: "Beauty & Personal Care",
    image: "https://images.unsplash.com/photo-1556228720-195a672e8a03?w=400&h=300&fit=crop",
    description: "Organic body lotion with shea butter and essential oils.",
    rating: 4.5,
    inStock: true
  },
  {
    id: 73,
    name: "Facial Cleanser Foam",
    price: 16.99,
    category: "Beauty & Personal Care",
    image: "https://images.unsplash.com/photo-1556228720-195a672e8a03?w=400&h=300&fit=crop",
    description: "Gentle foaming facial cleanser for all skin types.",
    rating: 4.3,
    inStock: true
  },
  {
    id: 74,
    name: "Hair Serum Repair",
    price: 34.99,
    category: "Beauty & Personal Care",
    image: "https://images.unsplash.com/photo-1522338242992-e1a54906a8da?w=400&h=300&fit=crop",
    description: "Intensive hair repair serum with argan oil and keratin.",
    rating: 4.4,
    inStock: false
  },
  {
    id: 75,
    name: "Sunscreen SPF 50",
    price: 22.99,
    category: "Beauty & Personal Care",
    image: "https://images.unsplash.com/photo-1556228720-195a672e8a03?w=400&h=300&fit=crop",
    description: "Broad-spectrum SPF 50 sunscreen with zinc oxide.",
    rating: 4.6,
    inStock: true
  },
  {
    id: 76,
    name: "Lip Balm Set Natural",
    price: 14.99,
    category: "Beauty & Personal Care",
    image: "https://images.unsplash.com/photo-1596462502278-27bfdc403348?w=400&h=300&fit=crop",
    description: "Set of 4 natural lip balms with different flavors.",
    rating: 4.2,
    inStock: true
  }
];

export const categories = ["All", "Electronics", "Clothing", "Home & Garden", "Food & Beverages", "Sports & Fitness", "Beauty & Personal Care"];